import React from "react";

const Divider = () => {
  return (
    <>
      <div className="flex justify-center items-center my-3">
        <div className="bg-secondaryText w-28 h-1 rounded-2xl"></div>
      </div>
    </>
  );
};

export default Divider;
